
import { Injectable } from '@angular/core';
import { PayrollGroupModel } from './model/payroll-group.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class PayrollGroupService {



  constructor(private http: HttpClient) { }

  getList(requestData:RequestData): Observable<any> {
    return this.http.post(environment.baseUrl+'/payroll-group/get', requestData);

  }

  getById(id:number): Observable<any> {
    return this.http.post(environment.baseUrl+'/payroll-group/get/'+id, '');

  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL

    return this.http.post(environment.baseUrl + '/payroll-group/export-list', requestData, { headers, responseType: 'blob' })
      .pipe(
        //catchError(this.handleError)
      );

  }

   /**
   * 
   * @param payrollInfo 
   * Calls the update API to insert/update the record
   */
   update(payrollInfo: PayrollGroupModel): Observable<any> { 
    if(payrollInfo.hasOwnProperty("id")){
      return this.http.post(environment.baseUrl+'/payroll-group/update', payrollInfo);
    } else{
      return this.http.post(environment.baseUrl+'/payroll-group/add', payrollInfo);
    }
  }


    /**
   * 
   * @param payrollInfo 
   * Calls the API to delete the record
   */
    delete(payrollInfo: PayrollGroupModel): Observable<any>  {
      return this.http.post(environment.baseUrl+'/payroll-group/delete/'+payrollInfo.id, payrollInfo);
    }

}
